// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/yxyweb/common/components/bill-design/billDesign.less
// module id = 2269
// module chunks = 0